

//changeOrderStColor 订单状态颜色 [1 待确认 2 待发货 3 配货中(导出) 4 待收货(导入) 5 已完成 6 已退货]
const getOrderStColor = (val) =>{
  if (val === 1) {
    return "background-color: rgb(244, 123, 37) ;color: #fff; "; //橙红色
  }
  if (val === 2) {
    return "background-color: rgb(49, 201, 46) ;color: #fff;"; // 绿色
  }
  if (val === 3) {
    return "background-color: rgb(93, 97, 191) ;color: #fff;"; // 藤紫色
  }
  if (val === 4) {
    return "background-color: rgb(254, 223, 37); color: #fff;"; //黄色
  }
  if (val === 5) {
    return "background-color: rgb(62, 186, 239); color: #fff;"; //蓝色
  }
  if (val === 6) {
    return "background-color: rgb(231, 76, 60) ;color: #fff;"; //深红色
  }
}

 //changeInvalIndColor 审核状态状态颜色 [0 作废单 1未审核 2 有效单 3 暂存单]
const getInvalIndColor = (val) =>{
  if (val === 0) {
    return "background-color: rgb(231, 76, 60) ;color: #fff;"; //深红色
  }
  if (val === 1) {
    return "background-color: #ffb800; color: #fff;"; //黄色
  }
  if (val === 2) {
    return "background-color: rgb(49, 201, 46); color: #fff;"; //绿色
  }
  if (val === 3) {
    return "background-color: rgb(62, 186, 239); color: #fff;"; //蓝色
  }
}


export default{
  getOrderStColor,
  getInvalIndColor
}





// WEBPACK FOOTER //
// ./src/utils/mallFun.js